/* CUCU motion (2026-08-28, fixed 2026-08-29) — the site's entire animation
   budget. ~1KB, no libraries, no scroll listeners: one IntersectionObserver
   adds a class once per element and CSS transitions opacity/transform 14px.
   Rules:
   - prefers-reduced-motion exits before anything is touched.
   - Elements already on screen at load are never armed — nothing above the
     fold flickers, and with no JS nothing is ever hidden (the classes that
     hide are only ever ADDED here).
   - Arming rides .cu-snap (transition:none) for one reflow, so the hidden
     state applies INSTANTLY — without it the !important reveal transition
     animates the hiding itself.
   - Stagger rides a --cu-d custom property because the .cu-io transition in
     cucu-peel.css is !important (see there for why) and an inline
     transition-delay would lose to it.
   - After each element finishes entering, the classes and property are
     removed, returning the element to its stylesheet-native state — that
     restores the sections' own fast hover transitions. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var SEL = '.cu-sechead,.cu-pc,.cu-line,.cu-way,.cu-spec,.cu-rev,.cu-fan .cell,.cu-fo-grid,.cu-su-form,.cu-pb,.cu-st__card';
  function settle(el, wait) {
    setTimeout(function () {
      el.classList.add('cu-snap');
      el.classList.remove('cu-io');
      el.classList.remove('cu-in');
      el.style.removeProperty('--cu-d');
      el.style.willChange = 'auto';
      void el.offsetWidth;
      el.classList.remove('cu-snap');
    }, wait);
  }
  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var t = entries[i].target;
      if (!entries[i].isIntersecting) continue;
      io.unobserve(t);
      if (t.classList.contains('cu-io')) {
        t.classList.add('cu-in');
        var d = parseFloat(t.style.getPropertyValue('--cu-d')) || 0;
        settle(t, d + 700);
      } else if (t.classList.contains('cu-io-peel')) {
        t.classList.add('cu-in');
      }
    }
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
  function arm() {
    var els = document.querySelectorAll(SEL);
    var vh = window.innerHeight;
    var lastParent = null;
    var k = 0;
    var armed = [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.classList.contains('cu-io') || el.classList.contains('cu-in')) continue;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) continue;
      el.classList.add('cu-snap');
      el.classList.add('cu-io');
      if (el.parentElement === lastParent || (el.parentElement && lastParent && el.parentElement.parentElement === lastParent.parentElement && el.classList.contains('cu-st__card'))) { k = Math.min(k + 1, 4); } else { lastParent = el.parentElement; k = 0; }
      if (k) el.style.setProperty('--cu-d', (k * 60) + 'ms');
      armed.push(el);
    }
    if (armed.length) {
      void document.body.offsetWidth;
      for (var n = 0; n < armed.length; n++) { armed[n].classList.remove('cu-snap'); io.observe(armed[n]); }
    }
    var peels = document.querySelectorAll('.cu-peel');
    for (var j = 0; j < peels.length; j++) {
      var p = peels[j];
      if (p.classList.contains('cu-io-peel') || p.classList.contains('cu-in')) continue;
      var pr = p.getBoundingClientRect();
      if (pr.top < vh * 0.92 && pr.bottom > 0) continue;
      p.classList.add('cu-io-peel');
      io.observe(p);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();
